// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Estilos específicos do relatório */\n[dir] .history-row[data-v-37aac13e] {\n  background-color: #f8f9fa;\n}\n[dir] .history-row[data-v-37aac13e]:hover {\n  background-color: #e9ecef;\n}\n", ""]);
// Exports
module.exports = exports;
